import styled from 'styled-components';
import {
  Box,
  Flex,
  Link,
  Modal,
  H1,
  Card,
  spacing,
  colors,
} from '@procore/core-react';

const SmallLogoWrapper = styled(Flex)`
  width: 75px;
  height: 75px;
  background: #ffffff;
  border: 1px solid #c2c2c2;
  padding: 10px;
`;

const MediumLogoWrapper = styled(Flex)`
  width: 100px;
  height: 100px;
  background: #ffffff;
  margin: 0px 38px 0px 0px;
  padding: 0px;
`;

const SmallLogo = styled.img`
  width: 100%;
  height: auto;
`;

const Container = styled(Box)`
  width: 100%;
  margin: 0 auto;
`;

const SlideContainer = styled(Box)`
  width: 100%;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  @media (min-width: 600px) {
    height: 290px;
  }

  @media (min-width: 768px) {
    height: 352px;
  }
`;

const Slide = styled.img`
  display: block;
  background-color: ${colors.white};
  border: 1px solid ${colors.gray85};
  border-radius: 4px;
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
`;

const EmptySlide = styled(Box)`
  background-color: ${colors.white};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-radius: 4px;
  object-fit: cover;
  border: 1px solid ${colors.gray85};
  cursor: pointer;
  height: 150px;

  .dialog {
    width: 100%;
    padding: ${spacing.lg}px;

    @media (min-width: 768px) {
      width: 312px;
      padding: 0;
    }
  }

  @media (min-width: 768px) {
    height: 352px;
  }
`;

const arrowMargin = 64;

const SlickWrapper = styled(Box)`
  margin: 0;
  width: 272px;

  @media (min-width: 552px) {
    width: 356px;
    margin: 0 ${arrowMargin}px;
  }

  @media (min-width: 600px) {
    width: 532px;
  }

  @media (min-width: 768px) {
    width: 644px;
  }

  .slick-arrow {
    &:before {
      color: #1d3243;
    }
  }

  &.thumbnail-carousel {
    .slick-track {
      display: flex;
      align-items: center;
      margin: 0 2px;
    }

    .slick-current {
      ${Slide} {
        border-color: #0033a1;
        box-shadow:
          0px 0px 0px 2px #0033a1 inset,
          0px 0px 0px 2px #0033a1;
      }
    }
  }
`;

const ArrowContainer = styled(Box)`
  background: white;
  border: 1px solid ${colors.gray85};
  width: 24px;
  height: 24px;
  border-radius: 50%;
  z-index: 1;

  &:before {
    content: none;
  }

  &.slick-prev {
    left: -32px;
  }

  &.slick-next {
    right: -32px;
  }

  svg {
    transform: scale(0.75);
  }

  &:hover {
    background: ${colors.gray85};
  }

  @media (min-width: 480px) {
    width: 48px;
    height: 48px;

    &.slick-prev {
      left: -64px;
    }

    &.slick-next {
      right: -64px;
    }

    svg {
      transform: scale(1);
    }
  }
`;

const OrangeLink = styled(Link)`
  color: #ff5200;
`;

const ImageModal = styled(Modal)`
  background: transparent;
  box-shadow: none;
  overflow: visible;
  > div {
    overflow: visible;
  }
`;

const ModalImageBody = styled(Box)`
  width: 90vw;
  height: 90vh;
  max-width: none;
  justify-content: center;
  overflow: visible;
  position: relative;
  display: flex;

  > div > div {
    max-height: none;
  }
`;

const ModalImage = styled.img`
  object-fit: contain;
  box-shadow: 0px 0px 32px -4px hsl(200deg 10% 15% / 64%);
  max-width: 100%;
  max-height: 100%;
`;

const CloseImageModalButton = styled.button`
  position: absolute;
  top: -10px;
  right: -10px;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  background-color: #000;
  border: 2px solid #fff;

  &:after {
    content: '\\00d7';
    color: #fff;
  }
`;

const NameText = styled(H1)`
  font-size: 44px;
  margin: 8px auto;
`;

const UnstyledLink = styled(Link)`
  color: inherit;
  text-decoration: none;

  &:hover {
    color: inherit;
    text-decoration: none;
  }

  &:focus {
    outline: none;
    box-shadow: none;
  }
`;

const DropdownMenu = styled(Card)`
  margin-top: ${spacing.sm}px;
  background-color: ${colors.white};
  border-radius: 8px;
  padding: ${spacing.sm}px;
  box-shadow: 0px 4px 28px 0px rgba(0, 0, 0, 0.28);
`;

const DropdownItem = styled(Box)`
  background-color: ${colors.white};
  border-radius: 8px;
  padding: ${spacing.md}px;
  margin: ${spacing.xs}px 0;
  width: 100%;

  &:hover {
    background-color: ${colors.gray94};
  }
`;

const Divider = styled.div`
  width: 100%;
  border-top: 1px solid ${colors.gray94};
  height: 2px;
  margin: ${spacing.sm}px 0;
`;

const LargeSpacingDivider = styled.div`
  width: 100%;
  border-top: 1px solid ${colors.gray94};
  height: 2px;
  margin: ${spacing.sm}px 0;
`;

const UnderlineModalHeader = styled(Modal.Header)`
  border-bottom: 1px solid ${colors.gray85};
`;

const MinWidthModal = styled(Modal)`
  width: 40%;
`;

const MinWidthModalBody = styled(Modal.Body)`
  width: 100%;
  max-width: 100%;
`;

const MediaContainer = styled(Flex)`
  max-width: 1200px;
  @media (max-width: 768px) {
    margin: 48px ${spacing.md}px;
  }

  @media (min-width: 769px) {
    margin: 48px 48px;
  }

  @media (min-width: 1200px) {
    margin: 48px 120px;
  }

  @media (min-width: 1920px) {
    margin: 48px 360px;
  }
`;

const SidebarContainer = styled(Flex)`
  justify-content: center;
  margin-left: 32px;

  @media (min-width: 1024px) {
    justify-content: flex-start;
    margin-left: 50px;
  }
`;

const UnderlineLink = styled(Box)`
  a {
    text-decoration: underline !important;
  }
`;

export {
  Container,
  SmallLogo,
  SmallLogoWrapper,
  MediumLogoWrapper,
  NameText,
  SlickWrapper,
  Slide,
  OrangeLink,
  ImageModal,
  ModalImageBody,
  ModalImage,
  CloseImageModalButton,
  UnstyledLink,
  DropdownMenu,
  DropdownItem,
  Divider,
  LargeSpacingDivider,
  ArrowContainer,
  UnderlineModalHeader,
  MinWidthModal,
  MinWidthModalBody,
  MediaContainer,
  SidebarContainer,
  UnderlineLink,
  EmptySlide,
  SlideContainer,
};
